// extracted by mini-css-extract-plugin
export default {"content":"style_content__vy81M","leftSide":"style_leftSide__BeoQb","rightSide":"style_rightSide__r4C5e","type":"style_type__lQI0Z"};